import { defaultIsValue } from './OperatorValidators';
import { makeOperator } from './Operator';
export default makeOperator({
  name: 'Greater',
  values: [{
    name: 'value',
    isValid: defaultIsValue
  }]
});